'use client';

import { useEffect } from 'react';

import { Button } from '@/app/components/button';
import { IconArrowBack } from '@/app/components/icons/ui-actions/icon-arrow-back';
import { IconClose } from '@/app/components/icons/ui-actions/icon-close';
import { BaseDealerModal } from '@/app/components/shared/dealer/components/shared/base-dealer-modal';
import { SearchBox } from '@/app/components/shared/dealer/components/shared/smart-search/search-box';
import { trackDealer } from '@/app/components/shared/dealer/utils/tracking';
import { type BaseSearchBoxProps } from '@/app/components/shared/dealer/utils/types';
import { createDataAttributes } from '@/app/utils/createDataAttributes';

export const DealerSearchOverlay = ({
  isOpen,
  onClose,
  searchBoxProps,
}: BaseSearchBoxProps) => {
  useEffect(() => {
    if (!isOpen) return;
    trackDealer({
      group: 'components/shared/dealer/shared/smart-search/search-overlay',
    });
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <BaseDealerModal isOpen={isOpen} onClose={onClose}>
      <div className="relative flex items-center justify-between px-4 pt-3 pb-2 xl:px-10 xl:pt-10 xl:pb-6">
        <Button
          className="xl:hidden"
          variant="tertiary"
          color="black"
          aria-label="Back"
          iconBefore={<IconArrowBack />}
          onClick={onClose}
          {...createDataAttributes({
            test: 'back-button',
          })}
        />
        <span
          className="text-sub-h3 font-noto-bold xl:text-sub-h1"
          {...createDataAttributes({
            test: 'title',
          })}
        >
          ค้นหาโชว์รูม / ศูนย์บริการ
        </span>
        <Button
          className="pointer-events-none invisible xl:pointer-events-auto xl:visible"
          variant="tertiary"
          aria-label="Close"
          color="black"
          iconBefore={<IconClose />}
          onClick={onClose}
          {...createDataAttributes({
            test: 'modal-close-button',
          })}
        />
      </div>

      <SearchBox
        searchWrapperClassName="px-4 pb-3 xl:px-10 xl:pb-0"
        {...searchBoxProps}
        onClose={onClose}
        value={searchBoxProps?.value ?? ''}
      />
    </BaseDealerModal>
  );
};
